module.exports = __webpack_public_path__ + "assets/german-flag.48974e57.svg";